<template>
  <div id="device_tab"
       class="main-tab main-tab-o">
    <div class="dv-reds-top">
      <img src="../assets/images/icon_no_bg.png"
           class="img-reds-bg">
      <div class="dv-content-reds">
        <div class="dv-rou-content">
          <router-link class="tv-routor"
                       to='/'>首页</router-link>
          <div class="tv-routor">/</div>
          <router-link class="tv-routor"
                       to=''>院内公告</router-link>
        </div>
        <div class="dv-reds-item-bgs">
          <div class="dv-re-item"
               v-for="(item,index) in recruitlists"
               v-bind:key="item"
               @mouseover="MouseOver(index)"
               @mouseout="Mouseout(monindex = 100000)"
               :class='monindex === index ? "dv-re-items" : ""'
               @click="onDs(item.newsid)">
            <div class="tv-re-item-title"
                 :class='monindex === index ? "tv-re-item-titles" : ""'>{{item.title}}</div>
            <!-- <div class="tv-re-item-title1">职位描述：</div> -->
            <div class="tv-re-item-title2">{{ item.introduce }}</div>
            <div class="dv-news-date-jus">{{ item.createdate }}
              <img src="../assets/images/icon_home_right.png"
                   class="img-news-right">
            </div>

          </div>
          <div class="dv-fenyes">
            <el-pagination background
                           layout="prev, pager, next"
                           prev-text="上一页"
                           center
                           next-text="下一页"
                           :page-size='showCount'
                           :total="totalResult"
                           @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api/api'
export default {

  data () {
    return {
      monindex: 100000,
      showCount: 10,
      totalResult: '',
      currentPage: 1,
      recruitlists: []
    }
  },
  created () {
    this.noticelist()
  },
  methods: {
    MouseOver (index) {
      this.monindex = index
    },
    onDs (id) {
      this.$router.push({
        path: '/noticeds',
        query: {
          id: id
        }
      })
    },
    //分页切换
    handleCurrentChange (e) {
      console.log(e)
      this.currentPage = e
      this.noticelist()

    },
    //招聘信息列表
    noticelist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: this.currentPage,
        showCount: this.showCount,

      }
      api.noticelist(parm).then((res) => {
        this.recruitlists = res.data.list
        this.totalResult = res.data.page.totalResult
      })
    },
  }
}
</script>

<style>
.dv-reds-item-bgs {
  width: 100%;
  margin-top: 300px;
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.dv-fenyes {
  margin-top: 20px;
  margin-bottom: 30px;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
}
.dv-news-date-jus {
  font-size: 19px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  justify-content: space-between;
  text-align: left;
  display: flex;
  flex-direction: row;
  width: calc(100% - 40px);
  line-height: 30px;
  margin: 10px 0 0 20px;
  color: #666666;
}
</style>